'use strict'

export let english_endStage={
  Overview: {
    fields: {
      period: {
        title: "Stage period",
        help: "Select the actual period for this Stage. Double click on a date in the calendar to make it the starting date of the stage. Single click on a date to make it the end date."
      },
      summary: {
        help: "What was the main intention or goal with this stage and did we achieve it? Did we have any breakthroughs or major failures?",
        description:"Describe main objectives of this stage and to what extent these objectives were met"
      },
      performedAchivements: {
        title: "Delivered this Stage",
        help: "What did we deliver this stage? Is there something we planned to deliver, but did not complete?",
        description: "Describe the products delivered during this stage"

      },

      benefits: {
        help: "With this stage completed, are we on track to deliver the desired return of investment? If not, what is the difference and why? Any new benefits added to, or removed from, the business case during this stage?",
        description: "Describe how the planned benefits and the business case have been impacted by the execution of this stage"
      },
      time: {
        help:`What was the duration planned for this stage? Did we stay within the time constraints? If not, what was the main reason?
              Did we use any of the time tolerance for the stage?
              Did we have any formal exceptions changing the duration of the stage plan - if so, what was the change and why?
              How are we now forecasting remaining time for the project, and how does that forecast compare to the baseline project plan?`,
        description: "Describe the time objective for this stage and to what extent the execution of the stage happened within the planned time"
      },
      cost: {
        help:`What was the cost planned for this stage? Did we stay within the planned cost? If not, what was the main reason?
              Did we use any of the cost tolerance for the stage?
              Did we have any formal exceptions changing the stage cost - if so, what was the change and why?
              How are we now forecasting remaining cost for the project and how does that compare to the baseline project cost?`,
        description: "Summarize what the planned cost was for the stage, what the actual cost ended up being and explain any deviance"
      },

      quality: {
        help:`Did we have the needed clarity on requirements, formats or other quality criteria for the planned stage deliverables?
          Have products delivered this stage met the agreed requirements or quality criteria?
          If not, which products failed to meet which criteria and why?
          Have the acceptance methods (testing, reviews...) for the products this stage been applied as agreed?
          How are we now judging the overall quality delivered in the project, and will we meet the needed quality level for the end project product?`,
        description: "Describe to what extent the deliverables this stage met the requirements, formats or other quality criteria agreed up front"
      },
      scope: {
        help:`Did we in this stage have sufficient clarity on what to deliver?
              Did we deliver the products planned for? Did we do more or did we do less?
              Did we change any scope during this stage?
              Do we have sufficient clarity on what to deliver for the rest of the project - if not, what is missing?`,
        description: "Describe to what extent this stage delivered the products planned for"
      },

      risk: {
        help:"Have we managed to keep the risk level at the appropriate level during this stage? Has the total risk exposure increased or decreased for the project during this stage? Were new severe risks identified this stage? Were any important risk mitigations implemented?",
        description: "Describe how the risk level for the project has changed during this stage"
      },

      teamPerformance: {
        help: "Has there been sufficient clarity on roles and responsibilities this stage? Did the team have the skills and capacity needed? Did we have any changes to the team during the stage? If so, how did it affect the performance? Any particular good performance in the team to be recognized?",
        description: "Describe the project team’s performance, in particular, recognition of good performance."
      },
      lessonsDescription: {
        help: "What went well, what went badly and what are the recommendations for future stages and projects of similar nature? What are the key lessons learned? How should these lessons be stored and reused?",
        description: "Summarize the lessons learned in this stage."
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/progress/labels/english_endStage.js